/** Public marketing routes included in sitemap and prerender. */
export const PUBLIC_MARKETING_ROUTES = [
  '/',
  '/pricing',
  '/contact',
  '/uptime-monitoring',
  '/slack-uptime-alerts',
  '/email-uptime-alerts',
  '/public-status-pages',
  '/ssl-domain-monitoring',
  '/alternatives',
  '/terms',
  '/privacy',
  '/refund',
  '/cookies',
] as const

export type PublicMarketingRoute = (typeof PUBLIC_MARKETING_ROUTES)[number]
